import smoothScrollToEl from '../utility/smoothScrollToEl'

export default {
	methods: {
		smoothScrollToEl
	}
};
